package com.macrofocus.eflux.animation

import svgpanzoom.SvgPanZoomContext
import kotlin.math.max
import kotlin.math.min

class ZoomAnimation(private val svgPanZoomContext: SvgPanZoomContext, private val endZoom: Double, override var duration: Long, private val easing: Easing = Easing.LINEAR) :
    Animation {
    private var startZoom: Double? = null

    override fun start() {
        startZoom = svgPanZoomContext.getZoom()
    }

    override fun tick(time: Long) {
        startZoom?.let { startZoom ->
            val normalizedTime = max(0.0, min(1.0, time.toDouble() / duration))

            val diff = endZoom - startZoom
            val eased = easing.ease(normalizedTime, startZoom, diff, 1.0).toDouble()
            val min = min(startZoom, endZoom)
            val max = max(startZoom, endZoom)
            val capped = max(min, min(max, eased))

            svgPanZoomContext.zoom(capped)
        }
    }
}